

















import { computed, defineComponent, provide, reactive, ref, toRef, watch } from "@vue/composition-api";
import { UserPublicData } from "@scrile/api-provider/dist/api/UserPublicDataProvider";
import useAuthorisedOnly from "@/hooks/useAuthorisedOnly";
import useAuthUser from "@/hooks/useAuthUser";
import { ACTION_TYPES } from "@/store/const";
import emitter from "@/lib/emitter";
import { getProfileUrl } from "@/lib/urlHelpers";
import CallsLogger from "@/modules/callsLogger";
import EventTicketPurchaseModal from "@/components/EventTicketPurchaseModal";
import ConsumeController from "./components/ConsumeController";
import ProduceController from "./components/ProduceController";
import useEvents from "./hooks/useEvents";
import StreamModal from "../components/StreamModal.vue";

export default defineComponent({
  name: "StreamController",
  components: { StreamModal, ProduceController, ConsumeController, EventTicketPurchaseModal },
  props: {
    user: { type: Object as () => UserPublicData, required: true },
  },
  setup(props, { root }) {
    const { authUser } = useAuthUser();
    const isOwner = computed(() => authUser.value && props.user.id === authUser.value.id);
    const openModal = ref(true);
    const showPurchaseModal = ref(false);

    const onClose = () => {
      CallsLogger.collectLogs(`[STREAM CONTROLLER] - Close`, { streaming: false });
      root.$router.push(getProfileUrl(props.user));
    };

    const { contentFeed, paymentPackages, getEventsData } = useEvents();

    const getEvent = useAuthorisedOnly(async (eventId: string) => {
      await getEventsData(eventId);
      openModal.value = false;
      showPurchaseModal.value = true;
    });

    const onErrorHandler = async (errorData: Record<string, any>) => {
      try {
        await getEvent(errorData.eventId.toString());
      } catch (e) {
        emitter.on<any>(ACTION_TYPES.LOGIN, async () => {
          await getEvent(errorData.eventId.toString());
        });
      }
    };

    const onFinishBooking = () => {
      openModal.value = true;
      showPurchaseModal.value = false;
    };

    const provided: { user: UserPublicData | null } = reactive({ user: props.user });
    watch(toRef(props, "user"), user => (provided.user = user));
    provide("messageData", provided);

    if (props.user.role === "member") {
      onClose();
    }

    return {
      isOwner,
      openModal,
      contentFeed,
      paymentPackages,
      showPurchaseModal,
      onClose,
      onErrorHandler,
      onFinishBooking,
    };
  },
});
